module.exports = __webpack_public_path__ + "static/img/top01_car.74d0e32.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/TW/img/top01_car.png
// module id = T+Cf
// module chunks = 1